// extracted by mini-css-extract-plugin
module.exports = {"title":"basket_title__2syyz","header":"basket_header__2W9Hi","basketContent":"basket_basketContent__2BqOd","ordersList":"basket_ordersList__18gmc"};